import { fmtTime } from "@/lib/format";
import { deleteChatMessage, useAdminChat } from "@/lib/store";

/**
 * 主辦人的聊天室檢視。只能看與刪，不能以主辦人身分發言 ——
 * 每則訊息都必須對應到一位真實與會者，那是「幾桌的誰在說話」的前提。
 *
 * 現場活動一定需要能移掉不當內容，所以刪文不是可選功能。
 */
export function ChatModeration({ code }: { code: string }) {
  const view = useAdminChat(code);

  if (view === undefined) return <p className="text-sub text-[13px]">載入中…</p>;
  if (view === null) return null;

  if (view.messages.length === 0) {
    return <p className="text-sub py-4 text-center text-[13px]">還沒有人在聊天室說話</p>;
  }

  return (
    <div className="mt-3 flex max-h-[400px] flex-col overflow-y-auto">
      {view.messages.map((m) => (
        <div
          key={m.id}
          className="flex items-start gap-3 border-t border-line py-2.5 first:border-t-0"
        >
          <div className="min-w-0 flex-1">
            <div className="text-sub text-[11px]">
              {m.table && <span className="text-accent font-semibold">{m.table} 桌</span>}
              {m.table && " · "}
              {m.name} · {fmtTime(m.createdAt)}
            </div>
            <div className="mt-0.5 whitespace-pre-wrap break-words text-[14px]">{m.body}</div>
          </div>
          <button
            onClick={() => {
              if (confirm(`確定刪除 ${m.name} 的這則訊息？`)) void deleteChatMessage(m.id);
            }}
            className="btn btn-danger shrink-0 px-3 py-1.5 text-[12px]"
          >
            刪除
          </button>
        </div>
      ))}
    </div>
  );
}
